import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Megaphone, AlertCircle } from "lucide-react";

const CATS = {
  Reagendamiento: "bg-amber-50 text-amber-800 border-amber-200",
  Actualización: "bg-sky-50 text-sky-800 border-sky-200",
  Invitados: "bg-emerald-50 text-emerald-800 border-emerald-200",
  Comunicado: "bg-stone-100 text-stone-800 border-stone-200",
};

export default function Announcements() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/announcements")
      .then(r => setItems(r.data))
      .catch(() => setItems([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="announcements-page" className="section-pad">
      <div className="container-cg">
        <div className="overline text-[var(--brand-primary)]">Anuncios oficiales</div>
        <h1 className="font-serif-cg text-4xl sm:text-5xl lg:text-6xl tracking-tight mt-3">
          Comunicados del comité organizador.
        </h1>

        {loading && (
          <p className="mt-10 text-[var(--brand-muted)]">Cargando comunicados...</p>
        )}

        <div className="mt-12 space-y-5">
          {items.map((a, idx) => (
            <article
              key={a.id}
              data-testid={`announcement-${idx}`}
              className="card-cg p-6 md:p-8"
            >
              <div className="flex flex-wrap items-center gap-3">
                <span className={`text-xs px-3 py-1 border ${CATS[a.category] || CATS.Comunicado}`}>
                  {a.category}
                </span>
                {a.important && (
                  <span className="text-xs px-3 py-1 border border-red-200 bg-red-50 text-red-700 flex items-center gap-1">
                    <AlertCircle size={12} /> Importante
                  </span>
                )}
                <span className="text-xs text-[var(--brand-muted)] ml-auto">
                  {new Date(a.date).toLocaleDateString("es-MX", { year: "numeric", month: "long", day: "numeric" })}
                </span>
              </div>
              <h3 className="font-serif-cg text-2xl md:text-3xl tracking-tight mt-4 flex items-start gap-3">
                <Megaphone className="text-[var(--brand-primary)] shrink-0 mt-1.5" size={20} />
                {a.title}
              </h3>
              <p className="mt-3 text-[var(--brand-ink)]/85 leading-relaxed">{a.body}</p>
            </article>
          ))}
          {!loading && items.length === 0 && (
            <p className="text-[var(--brand-muted)]">No hay comunicados publicados por el momento.</p>
          )}
        </div>
      </div>
    </div>
  );
}
